import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ChangeStatusService } from '@intellio/shared/services';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ApplicationStatusesActions from './application-statuses.actions';

@Injectable()
export class ApplicationStatusesEffects {
  getApplicationStatuses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationStatusesActions.getApplicationStatuses),
      mergeMap(({ typeId }) =>
        this.changeStatusService.getStatusesForType(typeId).pipe(
          map((statuses) =>
            ApplicationStatusesActions.getApplicationStatusesSuccess({
              typeId,
              statuses: statuses.data,
            })
          ),
          catchError((error) =>
            of(
              ApplicationStatusesActions.getApplicationStatusesFailure({
                typeId,
                error,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private changeStatusService: ChangeStatusService
  ) {}
}
